
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { veiculoRoutes } from './veiculo.routes.module';
import { ConsultarComponent } from './consultar/consultar.component';
import { HistoricoComponent } from './historico/historico.component';
import { VeiculosCategoriasResolver } from 'app/resolvers/veiculos-categorias-resolver';
import { VeiculosPossesResolver } from 'app/resolvers/veiculos-posses-resolver';
import { EstadoResolver } from 'app/resolvers/estado-resolver';
import { PedidoVeiculosResolver } from 'app/resolvers/pedido-veiculos-resolver';
import { BuscarVeiculoContratoArrendamentoComponent } from './buscar-veiculo/buscar-veiculo-contrato-arrendamento.component';
import { DetalheHistoricoContratoArrendamentoComponent } from './detalhe-historico/detalhe-historico-contrato-arrendamento.component';
import { CadastroContratoArrendamentoComponent } from './cadastro-contrato-arrendamento/cadastro-contrato-arrendamento.component';
import { FiltroHistoricoContratoArrendamentoComponent } from './filtro-historico/filtro-historico-contrato-arrendamento.component';
import { HistoricoContratoArrendamentoComponent } from './historico-contrato-arrendamento/historico-contrato-arrendamento.component';
import { ModalAjusteContratoArrendamentoComponent } from './modal-ajuste-contrato-arrendamento/modal-ajuste-contrato-arrendamento.component';

@NgModule({
  declarations: [
    ConsultarComponent,
    HistoricoComponent,
    BuscarVeiculoContratoArrendamentoComponent,
    HistoricoContratoArrendamentoComponent,
    FiltroHistoricoContratoArrendamentoComponent,
    CadastroContratoArrendamentoComponent,
    DetalheHistoricoContratoArrendamentoComponent,
    ModalAjusteContratoArrendamentoComponent
   ],
   entryComponents: [
    ModalAjusteContratoArrendamentoComponent
   ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(veiculoRoutes)
  ],
  providers: [
    EstadoResolver,
    VeiculosCategoriasResolver,
    VeiculosPossesResolver,
    PedidoVeiculosResolver
  ]
})
export class VeiculoModule { }
